import { render, staticRenderFns } from "./imageUrl.vue?vue&type=template&id=2cb13ee6&scoped=true&"
import script from "./imageUrl.vue?vue&type=script&lang=js&"
export * from "./imageUrl.vue?vue&type=script&lang=js&"
import style0 from "./imageUrl.vue?vue&type=style&index=0&id=2cb13ee6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb13ee6",
  null
  
)

export default component.exports